var _circle, _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSection2Icon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40.5,
    r: 40.5,
    fill: "#E6E2E0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5961_151)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5961_151",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 23,
    width: 34,
    height: 34
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 23H24V57H58V23Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5961_151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.5001 27.2498H32.5001C30.9353 27.2498 29.6667 28.5183 29.6667 30.0831V52.7498C29.6667 54.3146 30.9353 55.5831 32.5001 55.5831H49.5001C51.0649 55.5831 52.3334 54.3146 52.3334 52.7498V30.0831C52.3334 28.5183 51.0649 27.2498 49.5001 27.2498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0003 34.3333C40.4399 34.3333 39.8922 34.4995 39.4263 34.8108C38.9603 35.1221 38.5971 35.5646 38.3826 36.0823C38.1683 36.6001 38.1121 37.1697 38.2214 37.7194C38.3308 38.2689 38.6006 38.7738 38.9969 39.1701C39.3931 39.5663 39.898 39.8362 40.4475 39.9456C40.9972 40.0548 41.5669 39.9987 42.0846 39.7843C42.6023 39.5699 43.0449 39.2066 43.3561 38.7407C43.6675 38.2747 43.8337 37.727 43.8337 37.1666C43.8337 36.4152 43.5352 35.6945 43.0038 35.1632C42.4724 34.6318 41.7517 34.3333 41.0003 34.3333Z",
    fill: "#4B5563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6668 45.6665C46.6668 44.5394 46.219 43.4584 45.422 42.6614C44.625 41.8643 43.5439 41.4165 42.4168 41.4165H39.5835C38.4564 41.4165 37.3753 41.8643 36.5783 42.6614C35.7813 43.4584 35.3335 44.5394 35.3335 45.6665C35.3335 46.0422 35.4828 46.4026 35.7484 46.6683C36.0141 46.9339 36.3744 47.0832 36.7502 47.0832H45.2502C45.6259 47.0832 45.9863 46.9339 46.2519 46.6683C46.5175 46.4026 46.6668 46.0422 46.6668 45.6665Z",
    fill: "#4B5563"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1672 24.4165H43.8338C44.2095 24.4165 44.5699 24.5658 44.8355 24.8314C45.1012 25.0971 45.2505 25.4574 45.2505 25.8332V27.2498H36.7505V25.8332C36.7505 25.4574 36.8997 25.0971 37.1654 24.8314C37.4311 24.5658 37.7914 24.4165 38.1672 24.4165Z",
    fill: "#6B7280"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5961_151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(24 23)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection2Icon1);
export default __webpack_public_path__ + "static/media/section-2-icon1.be8db3c863b604637f3fc5d170761824.svg";
export { ForwardRef as ReactComponent };